import React, { useEffect, useState } from "react";
import { useParams, useHistory, Link } from "react-router-dom";
import { GlobalIconNames } from "../../../utils/GlobalIconNames";
import Header from "../../common/Header";
import SideBar from "../../common/SideBar";
import AuditTrail from "./AuditTrail";
import PCTemplateList from "./PCTemplateList";
import axios from "axios";
import Swal from "sweetalert2";
function TemplatesTable() {
  const { type } = useParams();
  const history = useHistory();

  return (
    <>
      <Header></Header>
      <div
        className="content-wrapper d-flex flex-wrap new-standard-box"
        style={{ fontWeight: "0px" }}
      >
        <SideBar></SideBar>
        <div className="sidebar-right">
          <div className="sub-menu-content-block">
            {/* <Tabs /> */}
            <div className="sub-menu-right-block">
              <div className="wrap-box-right">
                <div className="my-tickets-heading-blk flex-direction mb-2">
                  <div className="d-flex align-items-center ">
                    <div className="name-w-head d-flex align-items-center ">
                      <h4 className="text-left-align landing-heading heading_color_dynamic">
                        Templates
                      </h4>
                    </div>
                      <div className="text-md-right action2-blk">
                        <div className="ticket-view-btn d-flex align-items-center">
                          <div className="add-new-ticket-bx">
                            <button
                              onClick={() => history.goBack()}
                              title="Back"
                              className="btn btn-white-bordered"
                            >
                              <i className="fal fa-angle-left"></i>Back
                            </button>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
                <div className="tabs-wrap">
                  <ul className="nav nav-pills mb-4" id="tabs" role="tablist">
                    <li
                      className="nav-item"
                      onClick={() =>
                        history.push("/project-center/templates/table")
                      }
                    >
                      <Link
                        className={`nav-link ${type == "table" ? "active" : ""
                          }`}
                        id="pills-tab1"
                        data-toggle="pill"
                        to="/project-center/templates/table"
                        href="#pills-tab11"
                        role="tab"
                        aria-controls="pills-tab11"
                        aria-selected="true"
                      >
                        {GlobalIconNames("details").html}
                      </Link>
                    </li>
                    {/* <li
                      className="nav-item"
                      onClick={() =>
                        history.push("/project-center/templates/auditTrail")
                      }
                      disabled={true}
                      aria-disabled={true}
                    >
                      <Link
                        className={`nav-link ${type == "auditTrail" ? "active" : ""
                          }`}
                        id="pills-tab2"
                        data-toggle="pill"
                        to="/project-center/templates/auditTrail"
                        href="#pills-tab12"
                        role="tab"
                        aria-controls="pills-tab12"
                        aria-selected="true"
                        disabled={true}
                        aria-disabled={true}
                      >
                        {GlobalIconNames("audittrail").html}
                      </Link>
                    </li> */}
                  </ul>
                  <div className="tab-content" id="pills-tabContent">
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab11"
                      role="tabpanel"
                      aria-labelledby="pills-tab1"
                    >
                      {type == "table" && <PCTemplateList />}                      
                    </div>
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab12"
                      role="tabpanel"
                      aria-labelledby="pills-tab2"
                    >
                      {type == "auditTrail" && <AuditTrail />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default TemplatesTable;
